import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { Form } from "react-bootstrap";
import { ArrowRight } from "iconsax-react";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";

import logo from "../../../image/authentication/authentication-logo.png";
import loginType from "../../../redux/actions/login/loginType";
import {
  registerApi,
  registerRequestCodeApi,
  registerRequestCodeVerificationApi,
} from "../../../utility/api/apiList";

import TimerComponent from "../countDown";
import RegisterForm from "./registerForm";
import OTPComponent from "../OTP";
import ButtonComponent from "../button";
import UserRoleSelection from "./userTypeAndGenderSelection";

import {
  StyledAuthenticationLogo,
  StyledAuthenticationLogoWrapper,
  StyledAuthenticationSection,
  StyledBackButton,
  StyledContainer,
  StyledForm,
  StyledFormGroup,
} from "./loginStyled";
import {
  AzStepConnector,
  AzStepIcon,
} from "../../../containers/forgetPass/styledForgetPassPage";

export default function HorizontalLabelPositionBelowStepper({ props }) {
  const dispatch = useDispatch();
  const loginDetail = useSelector((state) => state.loginDetail);

  useEffect(() => {
    document.title = "ثبت نام";
  }, []);

  const [activeStep, setActiveStep] = useState(0);
  //got code
  const [OTP, setOTP] = useState(new Array(5).fill(""));
  const [OTPError, setOTPError] = useState("");

  //register input value
  const [person, setPerson] = useState({
    firstName: "",
    familyName: "",
    nid: "",
    email: "",
    password: "",
    confirmPassword: "",
    type: "",
    gender: "",
  });

  const [personError, setPersonError] = useState({
    firstNameError: "",
    familyNameError: "",
    nidError: "",
    emailError: "",
    passwordError: "",
    confirmPasswordError: "",
  });

  const inputRef = useRef(null);
  const formRef = useRef(null);

  const handleSubmitVerification = (e) => {
    e.preventDefault();
    const userVerification = {
      code: OTP.join(""),
      phone: loginDetail.username,
    };
    axios
      .post(registerRequestCodeVerificationApi, userVerification)
      .then((response) => {
        setActiveStep(1);
      })
      .catch((error) => {
        setOTPError(error.response.data.code[0]);
      });
  };

  const handleGetCodeAgain = () => {
    const phone = {
      phone: loginDetail.username,
    };
    axios
      .post(registerRequestCodeApi, phone)
      .then(() => {
        setOTPError("");
      })
      .catch(() => {});
  };

  const handleBackRegisterGetCode = (e) => {
    dispatch({
      type: loginType.CHANGE_ACTIVE_STEP,
      payload: 0,
      username: loginDetail.username,
    });
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (
      person.firstName.length < 2 ||
      person.firstName.length > 25 ||
      person.familyName.length < 2 ||
      person.familyName.length > 25
    ) {
      if (person.firstName.length < 2 || person.firstName.length > 25) {
        setPersonError((prevPersonError) => {
          return {
            ...prevPersonError,
            firstNameError: "باید بین 2 تا 25 حرف انتخاب شود.",
          };
        });
      }
      if (person.familyName.length < 2 || person.familyName.length > 25) {
        setPersonError((prevPersonError) => {
          return {
            ...prevPersonError,
            familyNameError: "باید بین 2 تا 25 حرف انتخاب شود.",
          };
        });
      }
      return;
    }
    const Newuser = {
      first_name: person.firstName,
      last_name: person.familyName,
      phone: loginDetail.username,
      password: person.password,
      password_confirm: person.confirmPassword,
      code: OTP.join(""),
      nid: person.nid,
      email: person.email,
      type: person.type,
      gender: person.gender,
    };
    axios
      .post(registerApi, Newuser)
      .then((response) => {
        let prevPathPassed = "";
        if (props.location?.state) {
          prevPathPassed = props.location.state.prevPath;
        } else {
          prevPathPassed = "/";
        }
        dispatch({
          type: "START_LOGIN",
          username: loginDetail.username,
          password: person.password,
          prevPath: prevPathPassed,
        });
      })
      .catch((error) => {
        error.response?.data?.first_name
          ? setPersonError((prevPersonError) => {
              return {
                ...prevPersonError,
                firstNameError: error.response.data.first_name,
              };
            })
          : setPersonError((prevPersonError) => {
              return { ...prevPersonError, firstNameError: "" };
            });
        error.response?.data?.last_name
          ? setPersonError((prevPersonError) => {
              return {
                ...prevPersonError,
                familyNameError: error.response.data.last_name,
              };
            })
          : setPersonError((prevPersonError) => {
              return { ...prevPersonError, familyNameError: "" };
            });
        error.response?.data?.password
          ? setPersonError((prevPersonError) => {
              return {
                ...prevPersonError,
                passwordError: error.response.data.password,
              };
            })
          : setPersonError((prevPersonError) => {
              return { ...prevPersonError, passwordError: "" };
            });
        error.response?.data?.password_confirm
          ? setPersonError((prevPersonError) => {
              return {
                ...prevPersonError,
                confirmPasswordError: error.response.data.password_confirm,
              };
            })
          : setPersonError((prevPersonError) => {
              return { ...prevPersonError, confirmPasswordError: "" };
            });
        error.response?.data?.nid
          ? setPersonError((prevPersonError) => {
              return { ...prevPersonError, nidError: error.response.data.nid };
            })
          : setPersonError((prevPersonError) => {
              return { ...prevPersonError, nidError: "" };
            });
        error.response?.data?.email
          ? setPersonError((prevPersonError) => {
              return { ...prevPersonError, emailError: error.response.data.email };
            })
          : setPersonError((prevPersonError) => {
              return { ...prevPersonError, emailError: "" };
            });
      });
  };

  const handleRoleOfRegisterration = (e, selectedGender, selectedType) => {
    e.preventDefault();

    setPerson({ ...person, gender: selectedGender, type: selectedType });

    setActiveStep(2);
  };

  function getSteps() {
    return ["احراز هویت", "تعیین نقش", "ثبت اطلاعات"];
  }

  const registerPassStepsFunctions = [
    handleSubmitVerification,
    handleRoleOfRegisterration,
    handleRegister,
  ];

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <>
            <Form.Group className="text-center">
              <Form.Label htmlFor="password" className="d-block text-center">
                کد ارسال شده به شماره همراه
                <span className="text-primary"> {loginDetail.username}</span> را وارد
                کنید.
              </Form.Label>
              <OTPComponent
                setOTP={setOTP}
                OTP={OTP}
                errorMessage={OTPError}
              ></OTPComponent>
            </Form.Group>
            <div className="text-center mt-4">
              <TimerComponent handleGetCodeAgain={handleGetCodeAgain} />
              <ButtonComponent
                type="submit"
                className="px-5 mt-3 w-100"
                disabled={OTP.includes("")}
              >
                ارسال
              </ButtonComponent>
            </div>
          </>
        );
      case 1:
        return (
          <div>
            <UserRoleSelection
              formRef={formRef}
              handleSubmit={handleRoleOfRegisterration}
            />
          </div>
        );
      case 2:
        return (
          <RegisterForm
            person={person}
            setPerson={setPerson}
            personError={personError}
            inputRef={inputRef}
          />
        );
      default:
        return null;
    }
  }

  const steps = getSteps();

  return (
    <>
      <StyledAuthenticationSection>
        <StyledContainer>
          <StyledForm
            noValidate
            className="px-sm-5"
            onSubmit={registerPassStepsFunctions[activeStep]}
          >
            <StyledAuthenticationLogoWrapper className="mx-auto mb-0">
              <StyledAuthenticationLogo src={logo} alt="azeto-logo" />
              <h1 className="h6 text-center">فراموشی رمز عبور</h1>
            </StyledAuthenticationLogoWrapper>
            <StyledFormGroup>
              <Stepper
                activeStep={activeStep}
                alternativeLabel
                connector={<AzStepConnector />}
                className="px-0"
              >
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={AzStepIcon}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div className="my-4">{getStepContent(activeStep)}</div>
            </StyledFormGroup>
          </StyledForm>
          <StyledBackButton onClick={handleBackRegisterGetCode}>
            <ArrowRight size="32" color="var(--dark-color)" variant="Outline" />
          </StyledBackButton>
        </StyledContainer>
      </StyledAuthenticationSection>
    </>
  );
}
